export default {
    methods: {
        parsedVideo(initial_url) {
            initial_url = initial_url.replaceAll('<p>', '').replaceAll('</p>', '').replaceAll('<br>', '');

            const hrefRegex = /(<a href="([^"]+)"([^<]+))<\/a>/g;
            let url = '';

            url = initial_url.replace(hrefRegex, function () {
                return Array.prototype.slice.call(arguments)[2];
            });

            //if link is youtube
            if (url.match('^https://www.youtube.com/') || url.match('^https://youtu.be/') || url.match('^https://youtube.com/')) {
                let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                let match = url.match(regExp);

                if (match && match[2].length == 11) {
                    return 'https://www.youtube.com/embed/' + match[2];
                }
            }

            //link is vimeo (
            else if (url.match('https://player.vimeo.com/video/') || url.match('https://vimeo.com/')) {
                let regExp = /^.*(vimeo.com\/|v\/|u\/\w\/|\/|\|\))([^#\&\?]*).*(\/[^#\&\?]*)/;
                let match = url.match(regExp);

                if(url.includes('/event')){
                    if(url.includes('vimeo.com') && url.includes('/embed')){
                        return url;
                    } else if(match[2] === 'event') { // https://vimeo.com/event/{event_id}
                        return 'https://vimeo.com/event' + match[3] + '/embed';
                    } else if(match[1] === '/') { // https://vimeo.com/event/{event_id}/{private_hash}
                        const private_hash = match[3].slice(1); //
                        return 'https://vimeo.com/event/' + match[2] + '/embed' + '?h=' + private_hash;
                    } else {
                        return initial_url;
                    }
                }

                if (match && match[2] && match[3]) {
                    //normal vimeo.com/video_id
                    if (match[2] === 'vimeo.com' || match[2] === 'video') {
                        return 'https://player.vimeo.com/video' + match[3];
                    }

                    //unlisted vimeo.com/video_id/list_id
                    //should create: 'https://player.vimeo.com/video/{id1}?h={id2};
                    //slice is to remove the first '/' in second id
                    const id2 = match[3].includes('/') ? match[3].slice(1) : match[3];
                    return 'https://player.vimeo.com/video/' + match[2] + '?h=' + id2;
                }
            }

            return initial_url;
        }
    },
};
